import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../components/Admin/MenuDetalhes/AdminMenu";
//Components

import {
  Icon,
  Menu,
  Sidebar,
  Segment,
  Container,
  Header,
  Divider,
  Form,
  Message,
  Button,
  Select,
} from "semantic-ui-react";
import Uploader from "./components/uploader";
//Styles
import "../../assets/css/guia_pages.css";
import {producaov2} from "../../services/apis";

//Script
import "../../assets/js/home.js";

import { connect } from "react-redux";

//Styles
import "../../assets/css/guia_pages.css";
import swal from "sweetalert";

class CarrosseisMeusCursos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: true,
      loading: false,
      faixa_minimizada: false,
      menuVisible: false,
      area: [],
      selected: 1,
      imageLink: "",
      disabled: true,
    };
    this.nodes = [];
  }

  componentDidMount() {
    producaov2.get("/area-descricao").then((res) => {
      const areaCorp = res.data.map((area) => {
        return {
          key: area.areacorp.id,
          value: area.areacorp.id,
          text:
            area.areacorp.id === 1 ? "Lean seis sigma" : area.areacorp.nome_tab,
        };
      });
      this.setState({ area: areaCorp });
    });
  }

  changeArea(value) {
    this.setState({ selected: value });
  }

  handleUploadImage(e) {
    const fd = new FormData();
    fd.append("file", e.target.files[0]);
    fd.append("path", "digital-imagens");
    producaov2
      .post("/upload", fd)
      .then((res) => {
        this.setState({ imageLink: res.data.url });
        swal({
          title: "Sucesso =)",
          text: "Sua imagem acabou de ser registrada em nosso servidor",
          icon: res.data.url,
          button: "Continuar",
        });
        this.setState({ disabled: false });
      })
      .catch((err) => {
        swal({
          title: "Vixi... :(",
          text:
            "Parece que tivemos um problema com o servidor da aws... tente novamente",
          icon: "error",
          button: "Tentar novamente",
        });
      });
  }

  handleSubmitForm() {
    const { imageLink, selected } = this.state;

    if (!imageLink) {
      swal({
        title: "Algo esta errado aqui!",
        text: `Você não fez upload de nenhuma imagem, poderia verificar por gentilza?`,
        icon: "error",
      });
      return;
    }

    swal({
      title: "Confirmar ?",
      text: `Deseja mesmo alterar a imagem de todas as paginas de venda do tipo ${selected}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        producaov2
          .post("/admin/imagem/digital", { area: selected, url: imageLink })
          .then((res) => {
            swal("Imagem salva com sucesso", {
              icon: "success",
            });
            this.setState({ disabled: true });
          })
          .catch((err) => {
            swal(err.response.data.err, {
              icon: "error",
            });
          });
      } else {
        swal("Okay, qualquer coisa estou aqui");
      }
    });
  }

  render() {
    return (
      <div>
        <AdminMenu/>
        <Container style={{paddingTop:'10%'}}>
          <Segment style={{ height: "55vh", display:'flex',flexDirection:'column'}}>
            <Header>Edição de cabeçalho por área Pagina de vendas</Header>
            <Divider />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <div style={{ height: "20%" }}>
                <Form success>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px",
                    }}
                  >
                    <label
                      htmlFor=""
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      Escolha a área que deseja anexar a imagem
                    </label>
                    <Select
                      value={this.state.selected}
                      style={{ marginTop: "10px" }}
                      options={this.state.area}
                      onChange={(e, { value }) => this.changeArea(value)}
                    />
                  </div>
                </Form>
              </div>
              <div
                style={{
                  justifyContent: "flex-end",
                  height: "55%",
                  flexDirection: "column",
                }}
              >
                <Uploader changeInput={this.handleUploadImage.bind(this)} />
              </div>
              <div style={{display:'flex',height: "25%",justifyContent:'flex-end',alignItems:'flex-end'}}>

              <Button
                style={{width:'100%'}}
                disabled={this.state.disabled}
                onClick={() => this.handleSubmitForm()}
              >
                Submit
              </Button>
              </div>
            </div>
          </Segment>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({ view_by_tab: store.home.aba });
export default connect(mapStateToProps)(withRouter(CarrosseisMeusCursos));
